export let GOOGLE_MAPS_API_KEY = import.meta.env.GOOGLE_MAPS_API_KEY;
export const ENDPOINT_PARISHES = import.meta.env.ENDPOINT_PARISHES;
export const ENDPOINT_SCHOOLS = import.meta.env.ENDPOINT_SCHOOLS;
export const ENDPOINT_CEMETERIES = import.meta.env.ENDPOINT_CEMETERIES;
if (!GOOGLE_MAPS_API_KEY) {
  GOOGLE_MAPS_API_KEY = typeof window !== 'undefined' && '__DIOJOLIET_MAPS_INIT__' in window && window['__DIOJOLIET_MAPS_INIT__'].GOOGLE_MAPS_API_KEY || 'GOOGLE MAP API KEY REQUIRED';
}
export const ACTIVE_DATASET = typeof window !== 'undefined' && '__DIOJOLIET_MAPS_INIT__' in window && window['__DIOJOLIET_MAPS_INIT__'].FINDER_DATASET || 'parish';